import { Injectable } from '@angular/core'; 
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { WebStorageService } from 'src/app/_core/services/webstorage.service';
@Injectable()
export class QueryParamInterceptor implements HttpInterceptor {
    constructor(private webStorageService: WebStorageService) { }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //let sessionID = sessionStorage.getItem("ASPNET_SessionId"); 
      let sessionID = this.webStorageService.getItemFromSessionStorage('ASPNET_SessionId')
    if (sessionID) {
      const modifiedUrl = req.url.includes('?')
        ? `${req.url}&sessionID=${encodeURIComponent(sessionID)}`
        : `${req.url}?sessionID=${encodeURIComponent(sessionID)}`;

      const modifiedReq = req.clone({ url: modifiedUrl });
      return next.handle(modifiedReq);
    }

    return next.handle(req);
  }
}


